import { render } from "./Pemerintahan.vue?vue&type=template&id=3a64657d"
import script from "./Pemerintahan.vue?vue&type=script&lang=js"
export * from "./Pemerintahan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__